import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import { Label as LabelSvelte } from '@glance-networks/ui-core-components';

export const Label = (props) => {
    const size =
    props.size === 'xs'
      ? 'x-small'
      : props.size === '2xs'
        ? '2x-small'
        : props.size;

  const defineProps = {
    // Only pass defined values so DS defaults apply.
    size,
    color: props.color,
    weight: props.weight,
    defaultClass: props.defaultClass,
    // DS expects boolean/string; default is true.
    show: props.show ?? true,
    tag: props.tag,
    disabled: props.disabled,
    watchNode: props.watchNode,
    text: props.text,
    required: props.required,
    // Allow adding layout/styling classes from React.
    class: props.className ?? props.class,
  };

  return (
    <Svelte component={LabelSvelte} {...defineProps}>
      {props.children}
    </Svelte>
  );
};
